import React from "react";
import { useParams, Link } from "react-router-dom";
import StarRating from "./StarRating";
import ReviewSubmitForm from "./ReviewSubmitForm";

const PropertyTabs = ({ property, activeTab, setActiveTab, roomsRef, reviewStats }) => {
  const { id } = useParams();

  if (!property) return null;

  const reviews = property.reviews || [];
  const { totalReviews, avgRating, ratingCount, ratingPercentage, ratingLabel, dynamicCategories } = reviewStats;

  return (
    <div className="dltabsview">

      {/* Tabs */}
      <ul className="nav nav-tabs" role="tablist">
        {["overview", "rooms", "rules", "reviews", "similar"].map((tab) => (
          <li className="nav-item" key={tab}>
            <button
              className={`nav-link ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab === "overview" && "Overview"}
              {tab === "rooms" && "Rooms"}
              {tab === "rules" && "Property Rules"}
              {tab === "reviews" && "User Reviews"}
              {tab === "similar" && "Similar Properties"}
            </button>
          </li>
        ))}
      </ul>

      <div className="tab-content">

        {/* OVERVIEW */}
        {activeTab === "overview" && (
          <div className="tab-pane fade show active">
            <div className="tabinner">
              <h3>{property.title}</h3>
              <ul>
                <li>{property.guests} guests</li>
                <li>{property.bedrooms} bedrooms</li>
                <li>{property.beds} beds</li>
                <li>{property.bathrooms} bathrooms</li>
              </ul>

              <h3>About the Homestay</h3>
              <p>{property.description}</p>

              <h3>Amenities</h3>
              <div className="ammenties">
                {property.amenities?.map((a) => (
                  <span key={a.id}>
                    <i className="icon icon-check"></i>
                    <small>{a.name}</small>
                  </span>
                ))}
              </div>

              {property.nearby_attractions && property.nearby_attractions.length > 0 && (
                <>
                  <h3>Nearby Attractions</h3>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(2, 1fr)",
                      gap: "12px"
                    }}
                    className="nearbyattractionsgrid"
                  >
                    {property.nearby_attractions.map((place) => (
                      <div
                        key={place.place_id}
                        style={{
                          display: "flex",
                          gap: "12px",
                          alignItems: "flex-start",
                          padding: "12px",
                          border: "1px solid #e6e9ec",
                          borderRadius: "10px",
                          background: "#f7f8fa"
                        }}
                      >
                        <div
                          style={{
                            flexShrink: 0,
                            width: "38px",
                            height: "38px",
                            borderRadius: "9px",
                            background: "#eaf6ee",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "18px"
                          }}
                        >
                          {place.icon}
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <p style={{ fontSize: "14px", fontWeight: 600, margin: "0 0 4px", lineHeight: 1.3 }}>
                            {place.name}
                          </p>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "12.5px", color: "#5b6b7a" }}>
                            {place.rating != null && (
                              <span
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "3px",
                                  background: "#fff4e5",
                                  color: "#a9611a",
                                  padding: "1px 6px",
                                  borderRadius: "5px",
                                  fontWeight: 600,
                                  fontSize: "11.5px"
                                }}
                              >
                                ★ {place.rating}
                              </span>
                            )}
                            <span>{place.distance_km} km away</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* ROOMS */}
        {activeTab === "rooms" && (
          <div className="tab-pane fade show active">
            <div className="tabinner">
              <h3>Available Rooms</h3>

              {property.rooms && property.rooms.length > 0 ? (
                property.rooms.map((room) => (
                  <div
                    key={room.id}
                    className="p-0">
                    <div className="propertylistbx">
                      {/* Room Header */}
                      <div className="propertygallbx">
                        <div className="propertygallbxinner">
                          <img
                            src={room.cover_image || room.cover_image}
                            alt={room.title}
                          />
                        </div>
                        <div>
                          {room.images && room.images.length > 0 ? (
                            room.images.map((image, index) => (
                              <img style={{height: "80px", width: "80px", objectFit: "cover", margin: "5px"}} key={index} src={image.image} alt={`Room ${room.title} Image ${index + 1}`} />
                            ))
                          ) : (
                            <p>No images available</p>
                          )}
                        </div>
                      </div>
                      <div className="propertycontents">
                        <h3>{room.title}</h3>
                        <span className="badge">
                          {room.room_type}
                        </span>

                        <p>
                          {room.description !== "0"
                            ? room.description
                            : "Comfortable room with modern facilities"}
                        </p>

                        <div className="pricetext">
                          <span>
                            ₹{room.price_min}
                            {room.price_max !== "0" && <> – ₹{room.price_max}</>}
                          </span>
                          <span>/</span>
                          <span className="dtext">night</span>
                        </div>

                        <p>
                          + Taxes & Fees Will be applied.
                        </p>
                      </div>
                    </div>

                    {/* Capacity Section */}
                    <div className="row gx-2 gx-lg-3 mb-3 mb-md-0">
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4 mb-2 mb-md-3">
                        <div className="guestbx">
                          <div className="w-100">
                            <strong>{room.max_guests}</strong>
                            <div className="text-muted">Guests</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4 mb-2 mb-md-3">
                        <div className="guestbx">
                          <div className="w-100">
                            <strong>{room.max_adults}</strong>
                            <div className="text-muted">Adults</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4 mb-2 mb-md-3">
                        <div className="guestbx">
                          <div className="w-100">
                            <strong>{room.max_children}</strong>
                            <div className="text-muted">Children</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4 mb-2 mb-md-3">
                        <div className="guestbx">
                          <div className="w-100">
                            <strong>{room.bedrooms}</strong>
                            <div className="text-muted">Bedroom</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4 mb-2 mb-md-3">
                        <div className="guestbx">
                          <div className="w-100">
                            <strong>{room.beds}</strong>
                            <div className="text-muted">Bed</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4 mb-2 mb-md-3">
                        <div className="guestbx">
                          <div className="w-100">
                            <strong>{room.bathrooms}</strong>
                            <div className="text-muted">Bathroom</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Benefits */}
                    {room.benefits && (
                      <div className="mb-3">
                        <h3>Benefits</h3>
                        <div className="ammenties">
                          {JSON.parse(room.benefits).map((item, index) => (
                            <span key={index}>
                              <i class="icon icon-check"></i>
                              <small>{item}</small>
                            </span>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Amenities */}
                    {room.details && (
                      <div className="p-0">
                        <h3>Amenities</h3>
                        <div className="ammenties">
                          {JSON.parse(room.details).map((item, index) => (
                            <span key={index}>
                              <i class="icon icon-check"></i>
                              <small>{item}</small>
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p>No rooms available</p>
              )}
            </div>
          </div>
        )}


        {/* RULES */}
        {activeTab === "rules" && (
          <div className="tab-pane fade show active">
            <div className="tabinner">

              <h3 className="mb-3">Property Rules</h3>

              {/* Check-in / Check-out */}
              <div className="mb-3">
                <div className="d-flex justify-content-between border-bottom py-2">
                  <span className="fw-semibold">Check-in</span>
                  <span>{property?.property_rules?.check_in || "Not specified"}</span>
                </div>

                <div className="d-flex justify-content-between py-2">
                  <span className="fw-semibold">Check-out</span>
                  <span>{property?.property_rules?.check_out || "Not specified"}</span>
                </div>
              </div>

              {/* House Rules & Policies */}
              <div className="mb-3">
                <h5 className="mb-2">House Rules & Policies</h5>

                {property?.property_rules?.cancellation_policy ? (
                  <div className="policy-list">
                    {property?.property_rules?.cancellation_policy
                      .split(",")
                      .map((rule, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-start mb-2"
                        >
                          <span className="me-2 text-primary">•</span>
                          <span>{rule.trim()}</span>
                        </div>
                      ))}
                  </div>
                ) : (
                  <p className="text-muted mb-0">
                    No cancellation policy available
                  </p>
                )}
              </div>

              {/* House Rules */}
              <div>
                <h5 className="mb-2">House Rules</h5>
                <p className="mb-0">
                  {property?.property_rules?.house_rules ||
                    "No house rules specified"}
                </p>
              </div>

            </div>
          </div>
        )}


        {/* REVIEWS */}
        {activeTab === "reviews" && (
          <div className="tab-pane fade show active">
            <div className="tabinner">
              <div className="row">

                {/* LEFT SUMMARY */}
                <div className="col-12 mb-4">
                  <div className="rating-summary-card">

                    {/* HEADER */}
                    <div className="overall-rating-header">
                      <div className="rating-badge">{avgRating}</div>
                      <div className="rating-info">
                        <span className="rating-text">
                          {ratingLabel}
                        </span>
                        <small>{totalReviews} Ratings</small>
                      </div>
                    </div>
                    <div className="rating-categories">
                      <h6>Rating Categories</h6>

                      {dynamicCategories.length > 0 ? (
                        <ul>
                          {dynamicCategories.map((cat) => (
                            <li key={cat.name}>
                              {cat.name}
                              <span>{cat.avg}</span>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <small>No category data available</small>
                      )}
                    </div>
                    {/* RATING BARS */}
                    <div className="ratingbarouter">
                      {[
                        { label: "Excellent", star: 5 },
                        { label: "Very Good", star: 4 },
                        { label: "Average", star: 3 },
                        { label: "Poor", star: 2 },
                        { label: "Bad", star: 1 },
                      ].map((item) => (
                        <div className="rating-bar-row" key={item.star}>
                          <span>{item.label}</span>

                          <div className="progress">
                            <div
                              className="progress-bar"
                              style={{
                                width: `${ratingPercentage(
                                  ratingCount[item.star]
                                )}%`,
                              }}
                            ></div>
                          </div>

                          <span>
                            {ratingPercentage(ratingCount[item.star])}%
                          </span>
                        </div>
                      ))}
                    </div>

                  </div>
                </div>

                {/* RIGHT LIST */}
                <div className="col-12">
                  <div className="dltreviewouter">
                    <h3>User Reviews</h3>
                    <div className="dltreviewinner">
                      {totalReviews > 0 ? (
                        reviews.map((review) => (
                          <div key={review.id} className="reviewcard">
                            <div className="d-flex align-items-center gap-2 gap-md-3">
                              <div className="reviewuser">
                                {review.reviewer_avatar_url ? (
                                  <img
                                    src={review.reviewer_avatar_url}
                                    alt={review.reviewer_name}
                                  />
                                ) : (
                                  <span className="reviewuser-placeholder">
                                    {(review.reviewer_name || "G").charAt(0).toUpperCase()}
                                  </span>
                                )}
                              </div>
                              <div className="rewiewscontent">
                                <h4>
                                  {review.reviewer_name || "Guest"}
                                  {review.verified && <span className="verified-pill">✓ Verified</span>}
                                </h4>
                                <StarRating value={Number(review.rating)} />
                              </div>
                            </div>
                            <div className="reviewbtmct">
                              <p className="m-0">{review.review}</p>
                              {review.photos && review.photos.length > 0 && (
                                <div className="review-photostrip">
                                  {review.photos.map((photo) => (
                                    <a
                                      key={photo.id}
                                      href={photo.image_url}
                                      data-fancybox={`review-${review.id}`}
                                    >
                                      <img src={photo.image_url} alt="guest upload" />
                                    </a>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No reviews yet</p>
                      )}
                    </div>
                  </div>
                </div>
                {/* WRITE REVIEW */}
                <div className="col-12">
                  <ReviewSubmitForm stayId={id} />
                </div>
              </div>
            </div>
          </div>
        )}


        {/* SIMILAR */}
        {activeTab === "similar" && (
          <div className="tab-pane fade show active">
            <div className="tabinner">
              <h3>Similar Properties</h3>
              {property.nearby_places && property.nearby_places.length > 0 ? (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: "12px"
                  }}
                  className="nearbyattractionsgrid"
                >
                  {property.nearby_places.map((place) => (
                    <Link
                      to={`/property/${place.id}`}
                      key={place.id}
                      style={{
                        display: "flex",
                        gap: "12px",
                        alignItems: "center",
                        padding: "12px",
                        border: "1px solid #e6e9ec",
                        borderRadius: "10px",
                        background: "#f7f8fa",
                        textDecoration: "none",
                        color: "inherit"
                      }}
                    >
                      <div
                        style={{
                          flexShrink: 0,
                          width: "38px",
                          height: "38px",
                          borderRadius: "9px",
                          background: "#eaf6ee",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "18px"
                        }}
                      >
                        🏡
                      </div>
                      <div style={{ minWidth: 0 }}>
                        <p style={{ fontSize: "14px", fontWeight: 600, margin: "0 0 4px", lineHeight: 1.3 }}>
                          {place.name}
                        </p>
                        <span style={{ fontSize: "12.5px", color: "#5b6b7a" }}>{place.distance}</span>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <p>No similar properties found nearby.</p>
              )}
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default PropertyTabs;
